import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  constructor(private ngxSpinnerService: NgxSpinnerService) {}

  show() {
    this.ngxSpinnerService.show();
  }

  hide() {
    this.ngxSpinnerService.hide();
  }
}
